import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _styled from "styled-components";
import { useEffect, useState } from 'react';
import { SUBTITLE_LINE_HEIGHT_RATIO, subtitleXR } from "../../constants";
import { usePlaybackContext } from "../../context/Playback";
import { useResponsiveContext } from "../../context/Responsive";
import { useUIContext } from "../../context/UI";
import { createSubtitlesWrapperCss } from "./ExternalSubtitles.styles";
import { jsx as _jsx } from "react/jsx-runtime";
var ExternalSubtitles = function ExternalSubtitles(_ref) {
  var currentExternalSubtitles = _ref.currentExternalSubtitles;
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize,
    playerHeight = _useResponsiveContext.playerHeight;
  var _usePlaybackContext = usePlaybackContext(),
    currentTime = _usePlaybackContext.currentTime;
  var _useUIContext = useUIContext(),
    visibleUi = _useUIContext.visibleUi;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    currentSubtitle = _useState2[0],
    setCurrentSubtitle = _useState2[1];

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    setCurrentSubtitle(currentExternalSubtitles.find(function (c) {
      return currentTime >= c.start && currentTime <= c.end;
    }));
    // Ingoring currentExternalSubtitles because we're comparing the stringified version
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(currentExternalSubtitles), currentTime]);
  if (currentSubtitle) {
    var fontSize = subtitleXR[playerSize.valueByHeight] * playerHeight / 100;
    var lineHeight = fontSize * SUBTITLE_LINE_HEIGHT_RATIO;
    var subtitlesWrapperCss = createSubtitlesWrapperCss({
      fontSize: fontSize,
      lineHeight: lineHeight,
      textLength: currentSubtitle.text.length,
      visibleUi: visibleUi,
      isMd: playerSize.matches.md,
      isSm: playerSize.matches.sm
    });
    return /*#__PURE__*/_jsx(_StyledDiv, {
      className: "absolute text-center p-8 z-2 bg-base-main-80 text-white ".concat(visibleUi && !playerSize.matches.sm ? 'cui-is-hidden' : 'cui-is-visible'),
      $_css: subtitlesWrapperCss,
      children: currentSubtitle.text
    });
  }
  return null;
};
export default ExternalSubtitles;
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-qsxukk-0"
})(["", ""], function (p) {
  return p.$_css;
});